<button id="goToTop" [ngClass]="{ 'hide-bottom': !display }" (click)="gotoTop()">
  <fa-icon [icon]="faChevronUp" />
</button>
